// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","ScreenXXSMax":"(max-width: 543px)","recipe":"Gaffe09","image":"G18bf1a","blankImage":"Gd7c8fc","recipeTitle":"G5c961b","recipeDetails":"G83c42d"};